import { render, staticRenderFns } from "./FormA.vue?vue&type=template&id=08d8cdf4&scoped=true&"
import script from "./FormA.vue?vue&type=script&lang=js&"
export * from "./FormA.vue?vue&type=script&lang=js&"
import style0 from "./FormA.vue?vue&type=style&index=0&id=08d8cdf4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8cdf4",
  null
  
)

export default component.exports